import { render } from "./InjuryMonthAlysis.vue?vue&type=template&id=24414204&scoped=true"
import script from "./InjuryMonthAlysis.vue?vue&type=script&lang=js"
export * from "./InjuryMonthAlysis.vue?vue&type=script&lang=js"

import "./InjuryMonthAlysis.vue?vue&type=style&index=0&id=24414204&lang=scss&scoped=true"
import "./InjuryMonthAlysis.vue?vue&type=style&index=1&id=24414204&lang=scss&scoped=true"
import "./InjuryMonthAlysis.vue?vue&type=style&index=2&id=24414204&scoped=true&lang=css"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24414204"]])

export default __exports__